import type Insured from '@/modules/common/common/models/APP/Insured'
import { PetsInsuredCivilLiabilityToSave } from '../../models/MID/PetsInsuredCivilLiabilityToSave'
import { SaveCivilLiabilityResponsibleRequest } from '../../models/MID/requests/SaveCivilLiabilityResponsibleRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

export default class {
  static toRequest(
    quotationId: string,
    isLiabilityInsuredPolicyholder: boolean,
    civilLiabilityInsured: Insured
  ): SaveCivilLiabilityResponsibleRequest {
    const insured = new PetsInsuredCivilLiabilityToSave({
      isPolicyHolder: isLiabilityInsuredPolicyholder
    })
    if (!insured.isPolicyHolder) {
      insured.name = civilLiabilityInsured.userDetails.name!.toUpperCase()
      insured.firstSurname = civilLiabilityInsured.userDetails.surname1!.toUpperCase()
      insured.secondSurname = civilLiabilityInsured.userDetails.surname2!.toUpperCase()
      insured.documentType = civilLiabilityInsured.documentDetails.documentType
      insured.documentNumber = civilLiabilityInsured.documentDetails.documentNumber!
      insured.documentExpirationDate = civilLiabilityInsured.documentDetails.documentExpirationDate
        ? CommonMapper.toMiddlewareDate(
            civilLiabilityInsured.documentDetails.documentExpirationDate
          )!
        : undefined
      insured.nacionality = civilLiabilityInsured.addressDetails.country!
      insured.birthDate = civilLiabilityInsured.userDetails.birthDate
        ? CommonMapper.toMiddlewareDate(civilLiabilityInsured.userDetails.birthDate)!
        : undefined
      insured.sex = civilLiabilityInsured.userDetails.gender!
      insured.riskNumber = civilLiabilityInsured.riskNumber || 1 // can't be 0
      insured.email = civilLiabilityInsured.userDetails.email!
      insured.prefix = civilLiabilityInsured.userDetails.prefix!
      insured.mobilePhone = civilLiabilityInsured.userDetails.phone!
      insured.postalCode = civilLiabilityInsured.addressDetails.postalCode!
      insured.province = civilLiabilityInsured.addressDetails.province!
      insured.city = civilLiabilityInsured.addressDetails.city!
      insured.streetType = civilLiabilityInsured.addressDetails.streetType!
      insured.street = civilLiabilityInsured.addressDetails.address!
      insured.houseType = civilLiabilityInsured.addressDetails.houseType!
      insured.house = civilLiabilityInsured.addressDetails.roadNumber!
      insured.gateway = civilLiabilityInsured.addressDetails.gateway!
      insured.stair = civilLiabilityInsured.addressDetails.stair!
      insured.floor = civilLiabilityInsured.addressDetails.floor!
      insured.doorway = civilLiabilityInsured.addressDetails.doorway!
      insured.restAddress = civilLiabilityInsured.addressDetails.addressExtra!
      insured.addressNormalice = civilLiabilityInsured.addressDetails.addressNormalize
      insured.hasHealthPolicy =
        String(civilLiabilityInsured.hasHealthPolicy) === 'true' ? true : false
      insured.relationship
      insured.policyHolderConsent = true
    }
    return new SaveCivilLiabilityResponsibleRequest({
      quotationId,
      insureds: [insured]
    })
  }
}
